// Which parts (by id from partsList.js) are used in each build step of the
// Game Designer Kit. IDs must match /app/frontend/src/data/partsList.js.

export const stepParts = {
  1: ["pcb"],
  2: ["big-spacer", "small-spacer", "screwdriver"],
  3: ["yellow-buttons", "red-buttons"],
  4: ["top-panel", "screw", "screwdriver"],
  5: ["bottom-panel", "screw", "screwdriver"],
  6: ["holder-tag"],
  7: ["microbit"],
  8: [], // Celebration screen — no parts button rendered (see FlowPage/StepCard).
};

/**
 * Resolve the list of part IDs for a given step, honouring a substep filter
 * when the entry supports it.
 */
export function partsForStep(stepNo, substepFilter) {
  const entry = stepParts[stepNo];
  if (!entry) return [];
  if (Array.isArray(entry)) return entry;

  const fallback = entry.all || [];
  if (!entry.subs || !substepFilter || substepFilter.length === 0) {
    return fallback;
  }
  const wanted = new Set();
  for (const idx of substepFilter) {
    const list = entry.subs[idx];
    if (list) list.forEach((id) => wanted.add(id));
  }
  if (wanted.size === 0) return fallback;
  const ordered = fallback.filter((id) => wanted.has(id));
  for (const id of wanted) {
    if (!ordered.includes(id)) ordered.push(id);
  }
  return ordered;
}
